import React from "react";

export default class Title extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="vdl-col-md-12">
        <div>
          <h1>{this.props.title}</h1>
          {this.props.welcomeBackFlag ? <h1>{this.props.username}</h1> : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/admin-login/title.js